import React from 'react'
import classNames from 'classnames'
import { useController, UseControllerProps } from 'react-hook-form'
import moment from 'moment'

import AntDatePicker from 'components/AntDatePicker'

import './index.less'

const DatePickerInput: React.FC<DatePickerInputProps> = (props) => {
  const {
    name,
    className,
    defaultValue,
    rules,
    shouldUnregister,
    ...restProps
  } = props

  const {
    field: {
      onChange,
      value,
      ref,
      onBlur,
    },
    fieldState: { invalid },
  } = useController({
    name,
    rules,
    defaultValue,
    shouldUnregister,
  })

  return (
    <AntDatePicker
      {...restProps}
      ref={ref}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      className={classNames(className, 'form__date-picker-input', {
        'form__date-picker-input--invalid': invalid,
      })}
    />
  )
}

interface DatePickerInputProps extends UseControllerProps {
  name: string,
  defaultValue?: [] | moment.Moment | null,
  className?: string,
  shouldUnregister?: boolean,
  multiple?: boolean,
  disabledDate?: (date: moment.Moment) => void,
  disablePastDates?: boolean,
  openInPlace?: boolean,
  scrollWhenOpen?: boolean,
  openInLayer?: boolean,
}

export default DatePickerInput
